




import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component<TaskBadge>({})
export default class TaskBadge extends Vue {
    @Prop({ type: String, required: true })
    public badgeSvg!: string // Path to badge image SVG file
    @Prop({ type: String, required: false, default: "50px" })
    public width?: string // Can be in px or %
    @Prop({ type: String, required: false, default: "Task Badge" })
    public name?: string // Name of badge, also to show in alt text
}
